/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Not_Found_TitleInputs */

const en_directory_not_found_title = /** @type {(inputs: Directory_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page doesn't exist`)
};

const zh_directory_not_found_title = /** @type {(inputs: Directory_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面不存在`)
};

/**
* | output |
* | --- |
* | "This page doesn't exist" |
*
* @param {Directory_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_not_found_title = /** @type {((inputs?: Directory_Not_Found_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Not_Found_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_not_found_title(inputs)
	return zh_directory_not_found_title(inputs)
});
export { directory_not_found_title as "directory.not_found.title" }